import { InjectionToken } from '@angular/core';
import { MpxCache } from 'osn-shared';

export const MPX_CACHE_FACTORY_TOKEN = new InjectionToken<() => MpxCache>('mpxCacheFactoryToken');
